<template>
    <div>
        <section class="signup_area">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-container d-flex">

                            <div class="form-wrap">
                                <div class="cardify signup_form">
                                    <div class="login--header pb-2">
                                        <h3>{{$store.getters.t('welcome')}}</h3>
                                        <p>{{$store.getters.t('auth_login_enter_credentials')}}</p>
                                        <div class="alert alert-danger mt-2 mb-0" role="alert"
                                             v-if="wrongCredentials === false">
                                            <span class="alert_icon lnr lnr-warning"></span>
                                            {{$store.getters.t('auth_login_wrong_credentials')}}
                                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                                <span class="lnr lnr-cross" aria-hidden="true"></span>
                                            </button>
                                        </div>
                                    </div>
                                    <!-- end .login_header -->

                                    <div class="login--form pt-0" v-if="isShowForm">

                                        <div class="form-group">
                                            <label for="phone">Email</label>
                                            <input id="phone" type="text" v-model="$v.formData.email.$model"
                                                   class="form-control" autocomplete="off">
                                            <div class="field-error-text" v-if="$v.formData.email.$error">The field has an invalid value
                                            </div>
                                        </div>

                                        <div class="form-group" v-if="needRole">
                                            <div class="custom-radio">
                                                <input type="radio" id="roleVolunteer" v-model="$v.formData.role.$model"
                                                       class="" value="volunteer" name="role" checked>
                                                <label for="roleVolunteer">
                                                    <span class="circle"></span>{{$store.getters.t('auth_login_role_volunteer')}}
                                                </label>
                                            </div>
                                            <div class="custom-radio">
                                                <input type="radio" id="roleZooOrgOwner"
                                                       v-model="$v.formData.role.$model" class=""
                                                       value="zooprotection_org_owner" name="role">
                                                <label for="roleZooOrgOwner">
                                                    <span class="circle"></span>{{$store.getters.t('auth_login_role_org')}}
                                                </label>
                                            </div>
                                            <div class="custom-radio">
                                                <input type="radio" id="roleDonatorBasic"
                                                       v-model="$v.formData.role.$model" class="" value="donator_basic"
                                                       name="role">
                                                <label for="roleDonatorBasic">
                                                    <span class="circle"></span>{{$store.getters.t('auth_login_role_donor')}}
                                                </label>
                                            </div>

                                            <div class="field-error-text" v-if="$v.formData.role.$error">{{$store.getters.t('auth_login_choose_account_type')}}</div>
                                        </div>


                                        <div class="d-flex justify-content-center">
                                            <button class="btn btn--md btn--round register_btn"
                                                    :disabled="$v.formData.$error" @click="login">{{$store.getters.t('auth_login_continue')}}
                                            </button>
                                        </div>

                                        <div class="text-center text-muted pt-5 pb-0">{{$store.getters.t('auth_login_or')}}</div>


                                        <div class="d-flex justify-content-center">
                                            <a @click.prevent="goToGoogle" href="/auth/google/redirect"
                                               class="btn btn--md btn--round register_btn"
                                            >
                                                <svg style="width: 30px; height: 30px; margin-right: 5px;" width="800px" height="800px" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M30.0014 16.3109C30.0014 15.1598 29.9061 14.3198 29.6998 13.4487H16.2871V18.6442H24.1601C24.0014 19.9354 23.1442 21.8798 21.2394 23.1864L21.2127 23.3604L25.4536 26.58L25.7474 26.6087C28.4458 24.1665 30.0014 20.5731 30.0014 16.3109Z" fill="#4285F4"/>
                                                    <path d="M16.2863 29.9998C20.1434 29.9998 23.3814 28.7553 25.7466 26.6086L21.2386 23.1863C20.0323 24.0108 18.4132 24.5863 16.2863 24.5863C12.5086 24.5863 9.30225 22.1441 8.15929 18.7686L7.99176 18.7825L3.58208 22.127L3.52441 22.2841C5.87359 26.8574 10.699 29.9998 16.2863 29.9998Z" fill="#34A853"/>
                                                    <path d="M8.15964 18.769C7.85806 17.8979 7.68352 16.9645 7.68352 16.0001C7.68352 15.0356 7.85806 14.1023 8.14377 13.2312L8.13578 13.0456L3.67083 9.64746L3.52475 9.71556C2.55654 11.6134 2.00098 13.7445 2.00098 16.0001C2.00098 18.2556 2.55654 20.3867 3.52475 22.2845L8.15964 18.769Z" fill="#FBBC05"/>
                                                    <path d="M16.2864 7.4133C18.9689 7.4133 20.7784 8.54885 21.8102 9.4978L25.8419 5.64C23.3658 3.38445 20.1435 2 16.2864 2C10.699 2 5.8736 5.1422 3.52441 9.71549L8.14345 13.2311C9.30229 9.85555 12.5086 7.4133 16.2864 7.4133Z" fill="#EB4335"/>
                                                </svg>

                                                {{$store.getters.t('auth_login_google')}}
                                            </a>
                                        </div>

                                    </div>
                                    <div class="login--form pt-0 d-flex justify-content-center flex-wrap mt-5" v-else>
                                        <div class="text-success text-center font-weight-bolder w-100">
                                            {{ message }}
                                        </div>
                                        <button class="btn btn--md btn--round register_btn" @click="isShowForm = true">
                                            {{$store.getters.t('auth_login_ok')}}
                                        </button>
                                    </div>

                                    <!-- end .login--form -->
                                </div>
                                <!-- end .cardify -->
                            </div>
                        </div>
                    </div>
                    <!-- end .col-md-12 -->
                </div>
                <!-- end .row -->
            </div>
            <!-- end .container -->
        </section>

    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import {mapMutations} from 'vuex';
import {required, email, requiredIf} from 'vuelidate/lib/validators';

export default {
    components: {},
    props: ['data'],
    data() {
        return {
            appRoutes: null,
            wrongCredentials: null,
            needRole: false,
            message: '',
            isShowForm: true,
            formData: {
                email: null,
                role: null,

                organization_id: null,
                entry_token: null,
            },
        }
    },
    created() {
        this.appRoutes = window.appRoutes;
    },
    mounted() {
        if (this.data) {
            this.formData.organization_id = this.data.organization && this.data.organization.id ? this.data.organization.id : null

            try {
                const queryString = window.location.search;
                const urlParams = queryString.length ? new URLSearchParams(queryString) : null;
                this.formData.entry_token = urlParams.has('entry_token') ? urlParams.get('entry_token') : null;

            } catch (error) {
                console.log(error)
            }
        }
    },
    methods: {
        ...mapMutations({
            setComponent: 'setterProfileTab',
        }),


        goToGoogle(){
            let url = '/auth/google/redirect';

            if(this.formData.organization_id) {
                url += `?organization_id=${this.formData.organization_id}`;
            }
            if(this.formData.entry_token) {
                url += `&entry_token=${this.formData.entry_token}`;
            }

            location.href = url;

        },

        login() {
            this.$v.$touch();

            if (this.$v.$error) {
                return false;
            }

            this.$v.$reset();

            const formData = {
                email: this.formData.email
            };

            if (this.needRole && !this.formData.organization_id) {
                formData.role = this.formData.role;
            }

            if (this.formData.organization_id) {
                formData.organization_id = this.formData.organization_id;
                if (this.formData.entry_token) {
                    formData.entry_token = this.formData.entry_token;
                }
            }

            axios.post('/auth/login', formData).then(response => {
                response = response.data.data;
                this.needRole = response.needRole;

                if (response.redirectUrl) {
                    this.setComponent('profile-component')
                    window.location.href = response.redirectUrl;
                } else if (!this.needRole) {
                    this.message = response.message;
                    this.isShowForm = false;

                    setTimeout(() => {
                        this.isShowForm = true;
                    }, 500000)
                }
            })
                .catch((error) => {

                })
                .then();
        }
    },
    watch: {
        'formData.email'(email) {
            this.needRole = false;
            this.formData.role = null;
        }
    },
    validations() {
        return {
            formData: {
                email: {
                    required,
                    email
                },
                role: {
                    required: requiredIf(function () {
                        return this.needRole;
                    })
                }
            }
        }
    },
}
</script>
